<template>
    <div class="flex flex-row gap-2">
        <input type="email" class="border rounded-full py-2 px-4 focus:outline-dark-blue grow" v-model="email"/>
        <button class="border py-2 px-4 rounded-full no-underline" @click="clicked_newsletter">{{ t('button') }}</button>
    </div>
</template>

<script setup lang="ts">
const { t } = useI18n({useScope: 'local'})
const email = ref('')

const clicked_newsletter = () => {
    navigateTo(`https://yipp.us6.list-manage.com/subscribe?u=dc6b9b56becd541aa768f7bcd&id=bf3ffd3c29&EMAIL=${email.value}`, {external: true})
}
</script>

<i18n lang="yaml">
en:
  button: Send
nl:
  button: Verstuur
</i18n>